function isOperation(obj) {
  return obj && typeof obj.title === "string" && typeof obj.sub_title === "string" && typeof obj.part_link === "string" && typeof obj.time_expiration === "string";
}
function isListOperations(data) {
  return Array.isArray(data) && data.every(isOperation);
}
function formmatDate(isoStr) {
  const date = new Date(isoStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const formatted = `${day}/${month}/${year}`;
  return formatted.includes("NaN") ? "00/00/0000" : formatted;
}
export {
  formmatDate,
  isListOperations,
  isOperation
};